import { forwardRef } from 'react';
import { Input } from '@/components/ui/input';

/**
 * PhoneInput accepts a value WITH or WITHOUT +91 prefix.
 * Displays only the 10-digit local portion. Stores back to parent in +91XXXXXXXXXX format.
 */
const PhoneInput = forwardRef(function PhoneInput({ value = '', onChange, placeholder = '10-digit phone', className = '', ...rest }, ref) {
  const stripPrefix = (v) => String(v || '').replace(/^\+91/, '').replace(/\D/g, '').slice(0, 10);
  const local = stripPrefix(value);

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange(digits ? `+91${digits}` : '');
  };

  return (
    <div className={`flex rounded-lg border bg-background h-9 overflow-hidden ${className}`}>
      <span className="px-2.5 flex items-center text-xs bg-muted text-muted-foreground border-r select-none">+91</span>
      <Input
        ref={ref}
        type="tel"
        inputMode="numeric"
        value={local}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={10}
        className="h-full border-0 rounded-none focus-visible:ring-0 px-2.5"
        {...rest}
      />
    </div>
  );
});

export default PhoneInput;
